import {NotificationTemplateRestDto} from "@/api/pharma-master-notification-template/models";
import {MailingMailTemplateRestDto} from "@/api/pharma-master-mailing-template-library/models";
import {SeasonEnum} from "@/api/enums/season-enum";
import {
    NotificationTemplateRestDtoModel
} from "@/models/api/pharma-master-notification-template/NotificationTemplateRestDtoModel";

export class MailingMailTemplateRestDtoModel implements MailingMailTemplateRestDto {

    name: string;
    description?: string | null;
    season_code?: SeasonEnum | null;
    labels: string[];
    notification_template: NotificationTemplateRestDto;

    constructor(
        name: string,
        labels: string[],
        notification_template: NotificationTemplateRestDto,
        description?: string | null,
        season_code?: SeasonEnum | null
    ) {
        this.name = name;
        this.labels = labels;
        this.notification_template = notification_template;
        this.description = description;
        this.season_code = season_code;
    }

    public static createWithDefaults(): MailingMailTemplateRestDtoModel {
        return new this('', [], NotificationTemplateRestDtoModel.createWithDefaults());
    }
}
